import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import MainLayout from 'components/v2/layout/MainLayout';
import { routesConfig } from 'config/routesConfig';
import Overlay from 'components/v2/overlay/Overlay';
import ServicesModal from 'modules/v2/servicesmodal/ServicesModal';

function AppRouter() {
  return (
    <BrowserRouter>
      <MainLayout>
        <Suspense fallback={<Overlay />}>
          <Routes>
            {routesConfig.map(route => {
              return <Route key={route.key} path={route.path} element={route.element} />;
            })}
          </Routes>
        </Suspense>
        <ServicesModal />
      </MainLayout>
    </BrowserRouter>
  );
}

export default AppRouter;
